import React from 'react';
import { Box } from '@wds/box';
import { t } from '@sm/intl';
import { Typography } from '@wds/typography';
import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import HeroFormCTA from '~app/components/HeroFormCTA';
import useStyle from '../useStyles';
import { COPY as SIGN_UP_COPY } from '~app/components/RebrandEpFormCore';
import { MetricsProps } from '~helpers/types';
import SMLogo from '~static/images/optionalPaths/sm-primary-logo.svg';
import { getSrc } from '~app/helpers/assetLoading';

const COPY = {
  logoAlt: 'Survey monkey logo',
  formHeader: 'Create an account',
  loginPrompt: 'Already have an account?',
  loginCta: 'Log in',
};

const HeroFormForOP = ({ metricsProps }: { metricsProps: MetricsProps }): React.ReactElement => {
  const { ctaForm, wrapper, login, loginWrapper, logo, spaceLeft } = useStyle();

  const { amplitudeEvent, templateType, surveyId, collectorId, respondentId, utSource, utSource2, utSource3 } =
    metricsProps;

  const HERO_FORM_CTA = {
    ctaFormEmail: t(SIGN_UP_COPY.HERO_FORM_CTA_EMAIL_ADDRESS),
    ctaFormEmailPlaceholder: t(SIGN_UP_COPY.HERO_FORM_CTA_EMAIL_ADDRESS_PLACEHOLDER),
    ctaFormNewsletterOptOut: t(SIGN_UP_COPY.HERO_FORM_CTA_NEWSLETTER_OPTOUT),
    ctaFormPassword: t(SIGN_UP_COPY.HERO_FORM_CTA_PASSWORD),
    ctaFormPasswordPlaceholder: t(SIGN_UP_COPY.HERO_FORM_CTA_PASSWORD_PLACEHOLDER),
    ctaFormPrivacyConsent: t(SIGN_UP_COPY.HERO_FORM_CTA_PRIVACY_CONSENT, {}, { html: true }),
    ctaFormSubmit: t(SIGN_UP_COPY.HERO_FORM_CTA_SUBMIT),
    disclaimer: t(SIGN_UP_COPY.HERO_FORM_CTA_DISCLAIMER),
    utSource,
    utSource2,
  };

  return (
    <Box display="flex" flexDirection="column" data-testid="HeroFormForOP" className={wrapper}>
      <img src={getSrc(SMLogo)} alt={COPY.logoAlt} className={logo} />
      <Box display="block" className={loginWrapper}>
        <Box pl={2} pr={2}>
          <Typography variant="body" color="dark" component="p" align="left">
            {COPY.loginPrompt}
            <a
              href={createURL('/login', {
                ut_source: utSource,
                ut_source2: utSource2,
                ut_source3: utSource3,
              })}
              className={`${login} ${spaceLeft}`}
              data-testid="HeroFormForOP__Login"
              data-sm-metrics={generateMetricsAttribute({
                data: {
                  amplitudeEvent,
                  itemSelected: 'secondary CTA',
                  templateType,
                  surveyId,
                  collectorId,
                  respondentId,
                  log: {
                    message: `${utSource}-${utSource2}-${utSource3}}`,
                  },
                },
              })}
            >
              {COPY.loginCta}
            </a>
          </Typography>
        </Box>
        <Box pt={4} pb={4}>
          <Typography component="div" align="left" variant="pageTitle">
            {COPY.formHeader}
          </Typography>
        </Box>
      </Box>
      <HeroFormCTA className={ctaForm} {...HERO_FORM_CTA} />
    </Box>
  );
};

export default HeroFormForOP;
